module.exports = __webpack_public_path__ + "static/media/bell-ship1.1b996065.aac";